<!--
 * 文件功能：首页视图（登录用户首页的路由入口包装层，Vue 3 版本）
 * 输入参数：无（由路由 "/" 渲染）
 * 输出参数：无（渲染 HomePage 主体组件与动森适配背景）
 * 返回值：无
 * 说明：由 Vue 2 class 组件（vue-property-decorator）重写为 Vue 3 `<script setup lang="ts">`；
 *       原整页背景图（home_background.jpg）已替换为动森羊皮纸风格半透明渐变背景，
 *       与全局天空渐变融合、保证内容可读性，业务逻辑全部在 HomePage 组件内实现。
 -->
<template>
  <div class="home">
    <HomePage />
  </div>
</template>

<script setup lang="ts">
import HomePage from '@/components/HomePage.vue'
</script>

<style scoped>
/* 动森适配背景：羊皮纸暖色半透明渐变 + 磨砂玻璃质感（替代原背景图片）；
   内边距防止内部侧栏/内容卡片边框与容器边框重叠贴合 */
.home {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.72) 0%,
    rgba(248, 248, 240, 0.82) 100%
  );
  backdrop-filter: blur(6px);
  border: 2px solid rgba(196, 184, 158, 0.45);
  border-radius: 18px;
  box-shadow: 0 3px 10px 0 rgba(61, 52, 40, 0.08);
  height: fit-content;
  padding: 16px;
}
</style>
